export const GMAIL_API_CLIENT_ID = "894155113559-7ie7avlq4e8u5qlv4d4osl0en5ts83h1.apps.googleusercontent.com";
export const GOOGLE_ANALYTICS_UA = "G-8RVL9GVQ62";